import React, { memo } from 'react';
import { systemPerformanceData } from '../utils/mockData';
import ChartCard from '../components/dashboard/ChartCard';
import { ShieldCheck, AlertTriangle, Clock, Activity, Server, Key, Bell, Flag } from 'lucide-react';
const System: React.FC = () => {
  return <div className="space-y-6" data-id="element-1668">
      <div data-id="element-1669">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1670">
          System Administration
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-1671">
          Monitor system health, security, and performance.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1672">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1673">
          <div className="flex items-center" data-id="element-1674">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-200" data-id="element-1675">
              <ShieldCheck size={24} data-id="element-1676" />
            </div>
            <div className="ml-5" data-id="element-1677">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1678">
                System Status
              </p>
              <p className="text-xl font-semibold text-green-600 dark:text-green-400" data-id="element-1679">
                Operational
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1680">
          <div className="flex items-center" data-id="element-1681">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1682">
              <Clock size={24} data-id="element-1683" />
            </div>
            <div className="ml-5" data-id="element-1684">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1685">
                Avg Response Time
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-1686">
                142ms
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1687">
          <div className="flex items-center" data-id="element-1688">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-yellow-100 dark:bg-yellow-900 text-yellow-600 dark:text-yellow-200" data-id="element-1689">
              <AlertTriangle size={24} data-id="element-1690" />
            </div>
            <div className="ml-5" data-id="element-1691">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1692">
                Active Alerts
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-1693">
                3
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1694">
          <div className="flex items-center" data-id="element-1695">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-purple-100 dark:bg-purple-900 text-purple-600 dark:text-purple-200" data-id="element-1696">
              <Activity size={24} data-id="element-1697" />
            </div>
            <div className="ml-5" data-id="element-1698">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1699">
                API Calls Today
              </p>
              <p className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-1700">
                1.2M
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1701">
        <ChartCard title="System Performance" subtitle="Response time and errors over the last 24 hours" data={systemPerformanceData} type="line" dataKeys={['responseTime', 'errors']} colors={['#3B82F6', '#EF4444']} data-id="element-1702" />
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1703">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1704">
            System Alerts
          </h3>
          <div className="space-y-4" data-id="element-1705">
            <div className="bg-yellow-50 dark:bg-yellow-900/30 border-l-4 border-yellow-400 dark:border-yellow-500 p-4" data-id="element-1706">
              <div className="flex items-start" data-id="element-1707">
                <div className="flex-shrink-0" data-id="element-1708">
                  <AlertTriangle className="h-5 w-5 text-yellow-400 dark:text-yellow-500" data-id="element-1709" />
                </div>
                <div className="ml-3" data-id="element-1710">
                  <p className="text-sm font-medium text-yellow-800 dark:text-yellow-200" data-id="element-1711">
                    High API Usage
                  </p>
                  <p className="mt-1 text-sm text-yellow-700 dark:text-yellow-300" data-id="element-1712">
                    API calls have increased by 25% in the last hour.
                  </p>
                  <p className="mt-1 text-xs text-yellow-600 dark:text-yellow-400" data-id="element-1713">
                    2023-06-10 09:45:23
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-red-50 dark:bg-red-900/30 border-l-4 border-red-400 dark:border-red-500 p-4" data-id="element-1714">
              <div className="flex items-start" data-id="element-1715">
                <div className="flex-shrink-0" data-id="element-1716">
                  <AlertTriangle className="h-5 w-5 text-red-400 dark:text-red-500" data-id="element-1717" />
                </div>
                <div className="ml-3" data-id="element-1718">
                  <p className="text-sm font-medium text-red-800 dark:text-red-200" data-id="element-1719">
                    Database Connection Issues
                  </p>
                  <p className="mt-1 text-sm text-red-700 dark:text-red-300" data-id="element-1720">
                    Intermittent connection failures to the user database.
                  </p>
                  <p className="mt-1 text-xs text-red-600 dark:text-red-400" data-id="element-1721">
                    2023-06-10 08:32:15
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-yellow-50 dark:bg-yellow-900/30 border-l-4 border-yellow-400 dark:border-yellow-500 p-4" data-id="element-1722">
              <div className="flex items-start" data-id="element-1723">
                <div className="flex-shrink-0" data-id="element-1724">
                  <AlertTriangle className="h-5 w-5 text-yellow-400 dark:text-yellow-500" data-id="element-1725" />
                </div>
                <div className="ml-3" data-id="element-1726">
                  <p className="text-sm font-medium text-yellow-800 dark:text-yellow-200" data-id="element-1727">
                    Memory Usage Warning
                  </p>
                  <p className="mt-1 text-sm text-yellow-700 dark:text-yellow-300" data-id="element-1728">
                    Server memory usage has reached 85% capacity.
                  </p>
                  <p className="mt-1 text-xs text-yellow-600 dark:text-yellow-400" data-id="element-1729">
                    2023-06-10 07:15:42
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1730">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1731">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1732">
            Security Monitoring
          </h3>
          <div className="space-y-4" data-id="element-1733">
            <div className="flex items-center justify-between" data-id="element-1734">
              <div className="flex items-center" data-id="element-1735">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1736">
                  <Key size={20} data-id="element-1737" />
                </div>
                <div className="ml-4" data-id="element-1738">
                  <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1739">
                    Failed Login Attempts
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1740">
                    Last 24 hours
                  </p>
                </div>
              </div>
              <span className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-1741">
                24
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-1742">
              <div className="flex items-center" data-id="element-1743">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1744">
                  <ShieldCheck size={20} data-id="element-1745" />
                </div>
                <div className="ml-4" data-id="element-1746">
                  <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1747">
                    Security Scans
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1748">
                    Last 24 hours
                  </p>
                </div>
              </div>
              <span className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-1749">
                3
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-1750">
              <div className="flex items-center" data-id="element-1751">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1752">
                  <Flag size={20} data-id="element-1753" />
                </div>
                <div className="ml-4" data-id="element-1754">
                  <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1755">
                    Suspicious Activities
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1756">
                    Last 24 hours
                  </p>
                </div>
              </div>
              <span className="text-xl font-semibold text-gray-900 dark:text-white" data-id="element-1757">
                7
              </span>
            </div>
          </div>
          <div className="mt-6" data-id="element-1758">
            <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 text-sm font-medium" data-id="element-1759">
              View Security Report
            </button>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1760">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1761">
            Feature Flags
          </h3>
          <div className="space-y-4" data-id="element-1762">
            <div className="flex items-center justify-between" data-id="element-1763">
              <div data-id="element-1764">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1765">
                  AI Insights Generation
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1766">
                  Automatic generation of financial insights
                </p>
              </div>
              <div className="relative inline-block w-12 h-6 rounded-full bg-gray-200 dark:bg-gray-700" data-id="element-1767">
                <input type="checkbox" id="toggle-ai-insights" className="sr-only" defaultChecked data-id="element-1768" />
                <span className="absolute left-1 top-1 bg-white dark:bg-gray-800 w-4 h-4 rounded-full transition-transform duration-200 transform translate-x-6" data-id="element-1769"></span>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1770">
              <div data-id="element-1771">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1772">
                  Premium Features Preview
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1773">
                  Allow free users to preview premium features
                </p>
              </div>
              <div className="relative inline-block w-12 h-6 rounded-full bg-gray-200 dark:bg-gray-700" data-id="element-1774">
                <input type="checkbox" id="toggle-premium-preview" className="sr-only" defaultChecked data-id="element-1775" />
                <span className="absolute left-1 top-1 bg-white dark:bg-gray-800 w-4 h-4 rounded-full transition-transform duration-200 transform translate-x-6" data-id="element-1776"></span>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1777">
              <div data-id="element-1778">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1779">
                  New Investment Platform
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1780">
                  Beta access to new investment discovery tools
                </p>
              </div>
              <div className="relative inline-block w-12 h-6 rounded-full bg-gray-200 dark:bg-gray-700" data-id="element-1781">
                <input type="checkbox" id="toggle-investment-platform" className="sr-only" data-id="element-1782" />
                <span className="absolute left-1 top-1 bg-white dark:bg-gray-800 w-4 h-4 rounded-full transition-transform duration-200 transform" data-id="element-1783"></span>
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1784">
              <div data-id="element-1785">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1786">
                  Enhanced Analytics
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1787">
                  Detailed spending pattern analysis
                </p>
              </div>
              <div className="relative inline-block w-12 h-6 rounded-full bg-gray-200 dark:bg-gray-700" data-id="element-1788">
                <input type="checkbox" id="toggle-enhanced-analytics" className="sr-only" defaultChecked data-id="element-1789" />
                <span className="absolute left-1 top-1 bg-white dark:bg-gray-800 w-4 h-4 rounded-full transition-transform duration-200 transform translate-x-6" data-id="element-1790"></span>
              </div>
            </div>
          </div>
          <div className="mt-6" data-id="element-1791">
            <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 text-sm font-medium" data-id="element-1792">
              Manage All Feature Flags
            </button>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1793">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1794">
          Notification Management
        </h3>
        <div className="space-y-4" data-id="element-1795">
          <div className="flex items-center justify-between p-4 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-1796">
            <div className="flex items-center" data-id="element-1797">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-200" data-id="element-1798">
                <Bell size={20} data-id="element-1799" />
              </div>
              <div className="ml-4" data-id="element-1800">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1801">
                  Scheduled Maintenance
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1802">
                  June 15, 2023 - 2:00 AM to 4:00 AM UTC
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2" data-id="element-1803">
              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200" data-id="element-1804">
                Scheduled
              </span>
              <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1805">
                Edit
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-1806">
            <div className="flex items-center" data-id="element-1807">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-200" data-id="element-1808">
                <Bell size={20} data-id="element-1809" />
              </div>
              <div className="ml-4" data-id="element-1810">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1811">
                  New Feature Announcement
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1812">
                  Enhanced Budget Analytics - June 12, 2023
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2" data-id="element-1813">
              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-1814">
                Active
              </span>
              <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1815">
                Edit
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-1816">
            <div className="flex items-center" data-id="element-1817">
              <div className="flex items-center justify-center h-10 w-10 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400" data-id="element-1818">
                <Bell size={20} data-id="element-1819" />
              </div>
              <div className="ml-4" data-id="element-1820">
                <p className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1821">
                  API Version Deprecation
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1822">
                  v1.0 API will be deprecated on July 1, 2023
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-2" data-id="element-1823">
              <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300" data-id="element-1824">
                Draft
              </span>
              <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300" data-id="element-1825">
                Edit
              </button>
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-1826">
          <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1827">
            Create Notification
          </button>
        </div>
      </div>
    </div>;
};
export default System;